import { TabbedPage } from "../../components/TabbedPage";
import { NotificationsLogPage } from "../notifications/NotificationsLogPage";
import { WebhooksPage } from "../webhooks/WebhooksPage";
import { BrandingSettingsPage } from "../settings/BrandingSettingsPage";

/** Merged Notifications Log + Webhooks + Branding & Domains — all three OWNER-only, so
 * the route-level guard in App.tsx (ROLES_WITH_BRANDING_ACCESS) covers all of them and
 * no per-tab role filtering is needed. */
export function SystemPage() {
  return (
    <TabbedPage
      title="System"
      defaultTab="branding"
      tabs={[
        { key: "branding", label: "Branding & Domains", content: <BrandingSettingsPage /> },
        { key: "notifications", label: "Notifications Log", content: <NotificationsLogPage /> },
        { key: "webhooks", label: "Webhooks", content: <WebhooksPage /> },
      ]}
    />
  );
}
